import type {
  EditorReadyFn,
  EditorScriptFlowAPI,
  FlowEditorSDK,
  GetAppManifestWrapper,
  TFunction,
} from '@wix/yoshi-flow-editor';

import { createAppManifest } from './components/MyAccount/manifest';
import { registerGfppEventListeners } from './editor/services/gfpp-event-listener';
import * as publicApi from './editor/services/public-api';

let flowAPI: EditorScriptFlowAPI;

const editorReady: EditorReadyFn = async (
  editorSDK,
  _appDefinitionId,
  _,
  _flowAPI,
) => {
  flowAPI = _flowAPI;

  registerGfppEventListeners(editorSDK, flowAPI.experiments);
};

const getAppManifest: GetAppManifestWrapper = async (_options, editorSDK) => {
  return createAppManifest(flowAPI.translations.t as TFunction, editorSDK);
};

const _exports = (editorSDK: FlowEditorSDK) => ({
  public: {
    refreshApp: () => {
      return publicApi.refreshApp(
        editorSDK,
        flowAPI.experiments,
        'PUBLIC_API_REFRESH',
      );
    },
    setAvatarVisibility: () => {
      console.warn(
        'setAvatarVisibility is deprecated you can safely stop invoking this method',
      );
    },
  },
});
export { editorReady, _exports as exports, getAppManifest };
